export default __webpack_public_path__ + "static/media/io-logo.8ab069d6.png";